import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Modal } from '@cancercentrum/rcc-bootstrap';
import { apiRequest } from '@cancercentrum/inca';
import { ListGroup, ListGroupItem, FormControl, Alert } from '@cancercentrum/rcc-bootstrap';
import { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import without from 'lodash/without';
import { InputGroup } from '@cancercentrum/rcc-bootstrap';
import { Checkbox } from '@cancercentrum/rcc-bootstrap';
import { formatISO, parseISO } from 'date-fns';
import { useSelector } from 'react-redux';
import { faCheckCircle, faPlus, faMinus, faTimesCircle, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { usePromiseHash } from '../../../../hooks/usePromiseHash';
import { LoadingAlert } from '../../../LoadingAlert';
import { AjaxErrorAlert } from '../../../AjaxErrorAlert';
import { useErrandPanelContext } from '../../ErrandPanel';
import { LeaveInInboxButton } from '../LeaveInInbox/LeaveInInboxButton';
export const DataAccessAdministrationModal = (props)=>{
    const { onCancel, onSuccess } = props;
    const ctx = useErrandPanelContext();
    const hasChanges = useSelector((x)=>x.data.past.length > 0);
    const { isLoading, result, error } = usePromiseHash(()=>({
            previouslyRemoved: apiRequest(`/Errands/${ctx.errand.id}/ContributingPositions/Deleted`),
            currentIds: apiRequest(`/Errands/${ctx.errand.id}/ContributingPositionIds`)
        }));
    const [searchText, setSearchText] = useState('');
    const [showOnlySelectedOrModified, setShowOnlySelectedOrModified] = useState(false);
    const [added, setAdded] = useState([]);
    const [removed, setRemoved] = useState([]);
    const itemsToShow = useMemo(()=>{
        const prevRemovedIds = (result?.previouslyRemoved ?? []).map((x)=>x.id);
        const cur = result?.currentIds || [];
        return ctx.reportingPositions.filter((x)=>x.fullNameWithCode.toLowerCase().includes(searchText.toLowerCase())).filter((x)=>!showOnlySelectedOrModified || cur.includes(x.id) || prevRemovedIds.includes(x.id) || added.includes(x.id));
    }, [
        ctx.reportingPositions,
        searchText,
        showOnlySelectedOrModified,
        added,
        result
    ]);
    const resultingContributingPositionIds = useMemo(()=>{
        const initial = result?.currentIds || [];
        return without([
            ...initial,
            ...added
        ], ...removed);
    }, [
        result,
        added,
        removed
    ]);
    return /*#__PURE__*/ _jsxs(Modal, {
        show: true,
        onHide: onCancel,
        backdrop: "static",
        bsSize: "xl",
        animation: false,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: /*#__PURE__*/ _jsx("strong", {
                        children: "Hantera datarättigheter"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    isLoading && /*#__PURE__*/ _jsx(LoadingAlert, {}),
                    !!error && /*#__PURE__*/ _jsx(AjaxErrorAlert, {
                        error: error
                    }),
                    !isLoading && !error && !!result && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            hasChanges && /*#__PURE__*/ _jsxs(Alert, {
                                bsStyle: "warning",
                                children: [
                                    'OBS! Eventulla ändringar i formulärets data kommer inte att sparas. Använd knappen "$',
                                    LeaveInInboxButton.text,
                                    '" om vill behålla ändringar i formuläret.'
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(InputGroup, {
                                children: [
                                    /*#__PURE__*/ _jsx(FormControl, {
                                        placeholder: "Sök bland positioner",
                                        value: searchText,
                                        onChange: (x)=>setSearchText(x.target.value)
                                    }),
                                    /*#__PURE__*/ _jsx(InputGroup.Addon, {
                                        children: /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                                            icon: faSearch
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(ListGroup, {
                                className: "my-4 overflow-auto",
                                style: {
                                    maxHeight: 400
                                },
                                children: itemsToShow.map((x)=>{
                                    const isPreviouslyAdded = result.currentIds.includes(x.id);
                                    const previouslyRemovedInfo = result.previouslyRemoved.find((y)=>y.id === x.id);
                                    const isCurrentlyRemoved = removed.includes(x.id);
                                    const isCurrentlyAdded = added.includes(x.id);
                                    return /*#__PURE__*/ _jsxs(ListGroupItem, {
                                        onClick: ()=>{
                                            const isAdded = isPreviouslyAdded && !isCurrentlyRemoved || isCurrentlyAdded;
                                            if (isAdded) {
                                                setAdded((a)=>without(a, x.id));
                                                if (isPreviouslyAdded) {
                                                    setRemoved((r)=>[
                                                            ...r,
                                                            x.id
                                                        ]);
                                                }
                                            } else {
                                                setRemoved((r)=>without(r, x.id));
                                                if (!isPreviouslyAdded) {
                                                    setAdded((a)=>[
                                                            ...a,
                                                            x.id
                                                        ]);
                                                }
                                            }
                                        },
                                        children: [
                                            !!previouslyRemovedInfo && !isCurrentlyAdded && /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                                                icon: faTimesCircle,
                                                className: "text-danger me-2",
                                                title: `Datarättighet borttagen ${formatISO(parseISO(previouslyRemovedInfo.deletedDate), {
                                                    representation: 'date'
                                                })} av ${previouslyRemovedInfo.deletedBy}`
                                            }),
                                            (isPreviouslyAdded || isCurrentlyAdded) && !isCurrentlyRemoved && /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                                                icon: faCheckCircle,
                                                className: "text-success me-2"
                                            }),
                                            (!isPreviouslyAdded && !isCurrentlyAdded || isCurrentlyRemoved) && !previouslyRemovedInfo && /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                                                icon: faCheckCircle,
                                                className: "text-secondary me-2"
                                            }),
                                            x.fullNameWithCode,
                                            isCurrentlyAdded && /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                                                icon: faPlus,
                                                className: "text-success ms-2"
                                            }),
                                            isCurrentlyRemoved && /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                                                icon: faMinus,
                                                className: "text-danger ms-2"
                                            })
                                        ]
                                    }, x.id);
                                })
                            }),
                            /*#__PURE__*/ _jsx(Checkbox, {
                                id: "check",
                                checked: showOnlySelectedOrModified,
                                onChange: (x)=>setShowOnlySelectedOrModified(x.target.checked),
                                children: "Visa endast valda, ändrade och tidigare borttagna"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faTimes,
                        onClick: onCancel,
                        bsStyle: "default-2",
                        children: "Avbryt"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faUser,
                        bsStyle: "primary",
                        className: "mr-2",
                        disabled: isLoading || !!error || !added.length && !removed.length,
                        onClick: ()=>onSuccess('Hantera_datarättigheter', {
                                contributingPositionIds: resultingContributingPositionIds
                            }),
                        children: "Sätt datarättigheter"
                    })
                ]
            })
        ]
    });
};
